import React from "react";
import "./Message.css";
import { AiFillTwitterCircle } from "react-icons/ai";
import { BsFacebook } from "react-icons/bs";
import { FaInstagramSquare } from "react-icons/fa";

import PM from "../../Assets/pm.jpg";
import shaza from "../../Assets/shaza.png";

const Message = () => {
  const messageData = [
    {
      id: 0,
      img: PM,
      text1:
        "Dear Youngsters! Always remember that you are the biggest asset of Pakistan. Almighty has blessed you with great potential and a lot of qualities.",
      text2:
        "Positively utilize your strengths and play role in making Pakistan a developed nation. You are the torch bearers of tomorrow. To empower our young population, we have launched several initiatives Under Prime Minister's Youth Programme.",
      text3:
        "Be a part of these initiatives, discover your hidden potential, and a bright future is waiting for you.",
      heading: "Shehbaz Sharif",
      about: "(Prime Minister, Pakistan)",
    },
    {
      id: 0,
      img: shaza,
      text1:
        "Leading the office of Youth Affairs is a great honor. As it enables me to work for the betterment of more than 68 percent population.",
      text2:
        "Our foremost goal is to facilitate youth in each and every field. PM Laptop Scheme, Loan scheme, Youth Development Center, and National Youth Commission are the initiatives through which we are trying to transform your bright future.",
      text3:
        "Get involved in our initiatives and play role in making a prosperous Pakistan.",
      heading: "Shaza Fatima Khwaja",
      about: "(SAPM on Youth Affairs)",
    },
  ];
  return (
    <>
      <div className="message-main-container">
        <h2>Our Message</h2>
        <div className="message-container">
          {messageData.map((items) => {
            return (
              <div key={items.id}>
                <div className="message-box">
                  <div className="message-img-box">
                    <img src={items.img} alt="Message section img" />
                  </div>
                  <p>{items.text1}</p>
                  <p>{items.text2}</p>
                  <p>{items.text3}</p>
                  <div className="message-bottom">
                    <div className="message-icon">
                      <AiFillTwitterCircle
                        style={{
                          width: "30px",
                          height: "30px",
                          marginRight: "5px",
                          color: "var(--fourth-color)",
                          cursor: "pointer",
                        }}
                      />
                      <BsFacebook
                        style={{
                          width: "30px",
                          height: "30px",
                          marginRight: "5px",
                          color: "var(--fourth-color)",
                          cursor: "pointer",
                        }}
                      />
                      <FaInstagramSquare
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "var(--fourth-color)",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    <h2>
                      <span className="before-content"></span>
                      {items.heading} <br />
                      <span>{items.about}</span>
                    </h2>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Message;
